<div class="loader" *ngIf="active"></div>
